import { combineReducers } from "redux";

import { ICityState } from "../types/city";
import { IConfigState } from "../types/config"; // Mathematical details, e.g. USD, Distance Units, etc
import { IScenariosState } from "../types/scenarios";

import cityReducer from './city';
import configReducer from './config';
import scenariosReducer from './scenarios';

export interface IAppState {
  city: ICityState;
  scenarios: IScenariosState;
  config: IConfigState;
}

const rootReducer = combineReducers<IAppState>({
  city: cityReducer,
  config: configReducer, // miscellaneous properties unrelated to scenarios or specific cities
  scenarios: scenariosReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.ts